import gql from 'graphql-tag';

export const FRAGMENT_CUSTOMER_RESOURCE = gql`
  fragment PerformanceCenterCustomerResource on PerformanceCenterCustomerResource {
    id
    content
    contentType
    name
    status
    tags
    file {
      originalUrl
      compressedUrl
      thumbnailUrl
      imageWidth
      imageHeight
      fileSize
      fileType
      fileName
      pageCount
    }
    createdAt
    userCreatedBy {
      id
      name
      email
    }
  }
`;
